import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import {mobile} from '~styles/global';
import resolveLink from '~utils/resolveLink';
import {Link} from 'gatsby';
import {Plus} from '~components/Svg';

const RowSelector = ({className, to, onClick, children, project, opacity, index, currentIndex, overIndex}) => {
	let title = project._type === 'director' ? project.title : project.client;
	let name = project._type === 'director' ? '' : project.projectName;

	if (!title) {
		title = name;
		name = '';
	}

	if (project.isSubItem) {
		title = (
			<>
				<PlusIcon /> {title}
			</>
		);
	}
	return to ? (
		<Wrap>
			<Inner className="h2" active={false}>
				<Title>
					<To className={className} to={resolveLink(to)} overIndex={overIndex} opacity={opacity(index)}>
						{title}
					</To>
				</Title>
				<ProjectName>
					<To className={className} to={resolveLink(to)} overIndex={overIndex} opacity={opacity(index)}>
						{name}
					</To>
				</ProjectName>
			</Inner>
		</Wrap>
	) : (
		<Wrap>
			<Inner className="h2" active={false}>
				<Title>
					<Click className={className} onClick={onClick} overIndex={overIndex} opacity={opacity(index)}>
						{title}
					</Click>
				</Title>
				<ProjectName>
					<Click className={className} onClick={onClick} overIndex={overIndex} opacity={opacity(index)}>
						{name}
					</Click>
				</ProjectName>
			</Inner>
		</Wrap>
	);
};
const Wrap = styled.div`
	grid-column: span 12;
	margin: 0 auto;
	width: 100%;
	text-align: left;
	pointer-events: none;
`;
const To = styled(Link)`
	width: 100%;
	text-align: left;
	transition: color 0.2s, opacity 0.4s;
	pointer-events: all;
	opacity: ${(props) => props.opacity};
	color: var(--white);
	:hover {
		color: var(--pink);
	}
`;
const Click = styled.button`
	text-align: left;
	pointer-events: ${(props) => (props.overIndex ? 'none' : 'all')};
	transition: color 0.2s, opacity 0.4s;
	opacity: ${(props) => props.opacity};
	:hover {
		opacity: 1;
	}
`;

const Inner = styled.div`
	display: grid;
	grid-template-columns: 51% 1fr;
	width: 100%;
	margin-bottom: 1px;
	transition: opacity 0.4s;
	${mobile} {
		grid-template-columns: 1fr;
	}
`;
const Title = styled.div``;

const PlusIcon = styled(Plus)`
	width: 18px;
	height: 18px;
	margin-right: 4px;
`;

const ProjectName = styled.div`
	text-align: right;
	${mobile} {
		display: none;
	}
`;

RowSelector.propTypes = {
	className: PropTypes.string,
	to: PropTypes.object,
	onClick: PropTypes.func,
	children: PropTypes.object,
	project: PropTypes.object,
	opacity: PropTypes.func,
	index: PropTypes.number,
	currentIndex: PropTypes.number,
};

export default RowSelector;
